<script>
  import { onMount } from 'svelte';
  import reveal from '../lib/actions/reveal.js';
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  let inView = false;
  let canvas;
  let raf;
  let dpr = 1;

  function drawNetwork(ctx, t) {
    // Use CSS pixels for layout; canvas is scaled by DPR via setTransform
    const w = ctx.canvas.width / dpr, h = ctx.canvas.height / dpr;
    ctx.clearRect(0,0,w,h);
    ctx.fillStyle = 'rgba(4,7,10,0.6)';
    ctx.fillRect(0,0,w,h);

    const nodes = 16;
    const r = Math.min(w,h) * 0.42; // slightly larger to better fill the panel
    const cx = w/2, cy = h/2;
    ctx.save();
    ctx.translate(cx, cy);
    for (let i=0; i<nodes; i++) {
      const a = (i/nodes) * Math.PI*2 + Math.sin(t*0.0003+i)*0.2;
      const x = Math.cos(a)*r*(0.85+0.1*Math.sin(t*0.0005+i));
      const y = Math.sin(a)*r*(0.85+0.1*Math.cos(t*0.0006+i));
      // connections
      for (let j=i+1; j<nodes; j+=4) {
        const a2 = (j/nodes) * Math.PI*2 + Math.cos(t*0.0003+j)*0.2;
        const x2 = Math.cos(a2)*r, y2 = Math.sin(a2)*r;
        const grad = ctx.createLinearGradient(x,y,x2,y2);
        grad.addColorStop(0, 'rgba(0,255,198,0.0)');
        grad.addColorStop(0.5, 'rgba(33,243,255,0.35)');
        grad.addColorStop(1, 'rgba(0,255,198,0.0)');
        ctx.strokeStyle = grad;
        ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(x,y); ctx.lineTo(x2,y2); ctx.stroke();
      }
      // node
      const pulse = 0.8+0.2*Math.sin(t*0.003+i);
      ctx.fillStyle = 'rgba(124,255,91,'+(0.35+0.25*Math.sin(i))*pulse+')';
      ctx.beginPath(); ctx.arc(x,y, 3+2*pulse, 0, Math.PI*2); ctx.fill();
    }
    ctx.restore();
  }

  onMount(() => {
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        inView = true; io.disconnect();
        const ctx = canvas.getContext('2d');
        dpr = window.devicePixelRatio || 1;
        const resize = () => {
          const {clientWidth:cw, clientHeight:ch} = canvas;
          canvas.width = Math.max(1, Math.floor(cw * dpr));
          canvas.height = Math.max(1, Math.floor(ch * dpr));
          ctx.setTransform(dpr,0,0,dpr,0,0);
        };
        resize();
        const onResize = () => resize();
        window.addEventListener('resize', onResize);
        const loop = (t) => { drawNetwork(ctx, t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', onResize); };
      }
    }, { threshold: .2 });
    io.observe(canvas);
  });
</script>

<section id="agentic" class="section" aria-label="Agentic Economy">
  <div class="container">
    <div class="grid" style="grid-template-columns: 1.1fr .9fr; gap: 26px; align-items: center;">
      <div use:reveal>
        <SectionHeader title="Agentic Economy" />
        <p style="color: var(--muted); font-size: 18px; line-height:1.7; max-width: 72ch; margin: 6px 0 10px;">
          Lumina introduces x402 to NFAs, the protocol that powers that agentic economy:
        </p>
        <ul style="line-height:1.9; color: var(--muted); font-size: 18px; padding-left: 18px; margin-top: 8px;">
          <li>Enables cross-chain coordination between NFAs</li>
          <li>Supports inter agent payments and data exchange</li>
          <li>Connects with the Virtuals ecosystem to unlock aGDP (agentic GDP)</li>
        </ul>
      </div>

      <div class="glass" use:reveal={{delay:120}} style="height: 380px; overflow: hidden;">
        <canvas bind:this={canvas} style="display:block; width:100%; height:100%"></canvas>
      </div>
    </div>
  </div>
</section>
